<mat-button-toggle-group [value]="size" (change)="updateSize()" #group="matButtonToggleGroup">
    <mat-button-toggle *ngFor="let i of [3,4,5,6,7,8]" [value]="i" [checked]="size === i">{{ i }}</mat-button-toggle>
</mat-button-toggle-group>
